
export default {
  props: {
    type: {type: String, default: 'regular'},
    title: {type: String, required: true},
    selected: {type: Boolean, required: true},
  },
  computed: {
    icon() {
      if (this.type === 'accept') return 'check'
      if (this.type === 'reject') return 'x-close'
      return undefined
    },
    icon_color() {
      if (this.type === 'accept') return 'var(--success-500)'
      if (this.type === 'reject') return 'var(--error-500)'
      return undefined
    },
  },
}
